<template>
  <div id="goback" @click="goback">
    <div class="btn"><a-icon type="left" />返回</div>
  </div>
</template>

<script>
export default {
  name: "Goback",
  data() {
    return {};
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
#goback {
  /* border-bottom: 1px solid grey; */
  height: 8vh;
  line-height: 8vh;
  font-size: 18px;
  cursor: pointer;
  overflow: hidden;
}
.btn {
  float: left;
  margin-left: 5vw;
}
#goback:hover {
  color: gray;
}
</style>


// WEBPACK FOOTER //
// src/components/Goback/Goback.vue